import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { readString } from 'react-papaparse';
import { apiClient, t } from '@cyberint/common-utils';
import * as S from './styled';

const CSVViewer = ({ file }) => {
  const [dataSheetObj, setDataSheetObj] = useState([[]]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const onUseEffect = async () => {
      if (!file?.url) return;

      setLoading(true);
      setError(false);

      try {
        const response = await apiClient.noCacheClient.get(file.url);
        const csvData = response.data;

        const jsonCSVArray = readString(csvData)?.data || [[]];
        const dataSheetJson = jsonCSVArray.map((row, rowIdx) => ({
          id: `row-${rowIdx}`,
          cells: row.map((cell, cellIdx) => ({
            value: cell,
            id: `${rowIdx}-${cellIdx}`
          }))
        }));

        setDataSheetObj(dataSheetJson);
        setLoading(false);
      } catch (err) {
        setError(t('common.failed_to_load_file'));
      }
    };

    onUseEffect();
  }, [file?.url]);

  if (loading) {
    return <S.StatusContainer>{t('common.loading_file')}</S.StatusContainer>;
  }

  if (error) {
    return <S.StatusContainer>{t('common.failed_to_load_file')}</S.StatusContainer>;
  }

  return (
    <S.CSVContainer>
      <S.CSVTable>
        <tbody>
          {dataSheetObj?.map((row, i) => (
            <tr key={row.id} className={i === 0 ? 'header-row' : 'data-row'}>
              {row.cells?.map(cell => (
                <td key={cell.id}>{cell.value}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </S.CSVTable>
    </S.CSVContainer>
  );
};

CSVViewer.propTypes = {
  file: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired
};

export default CSVViewer;
